import React from "react";
import Slider from "react-slick";
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class SpeciesScores extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      boatScores: [],
      logs: this.props.logs,
      speciesId: this.props.speciesId,
      speciesName: this.props.speciesName,
    }
  }
  
  componentDidMount() {
    this.getSpeciesPoints();
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, speciesId: newProps.speciesId, speciesName: newProps.speciesName});
    this.getSpeciesPoints(newProps.speciesId);
    
  }

  getSpeciesPoints(speciesId) {
    var boatTotals = [];
    var logs = this.state.logs;
    logs.forEach((boatLog) => {
      var totalPoints = 0;
      var speciesCount = 0;
      boatLog.boatCaughtFish.forEach((log) => {
        if(speciesId === log.speciesId && log.lbs > 0) {
          totalPoints = totalPoints + parseFloat(log.lbs);
        }
        if(speciesId === log.speciesId) {
          speciesCount++
        }
      });
      var points = parseFloat(totalPoints.toFixed(2));
      if(speciesCount > 0){
        var d = new Date(boatLog.lastFishTime);
        boatTotals.push({
          id: boatLog.boatId,
          boatName: boatLog.boatName,
          boatThm: boatLog.boatThm,
          total: points,
          lastFishTime: boatLog.lastFishTime,
          lastTime: parseInt(Math.round(d.getTime() / 1000))
        })
      }
    })
    this.scoreSortFilter(boatTotals);
  }

  scoreSortFilter(boatTotals) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    if(boatTotals && boatTotals.length >= 1) {
      boatTotals.sortOn("total", "lastTime");
      boatTotals.reverse();
    }
  
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    if(boatTotals && boatTotals.length >= 1) {
      var boatScoresArray = boatTotals.filter(filterByTotal);
    }
    
    this.setState({
      boatScores: boatScoresArray,
    })  
  }
  
  render() {
    
    const settings = {
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      vertical: true,
      verticalSwiping: true,
    };
    return (
        <div className="speciesScores-box">
          <div className="divisionText">{this.state.speciesName} Division</div>
          { this.state.boatScores ? <Slider {...settings}>
          { this.state.boatScores.map(log => (
            <div id='log-box' className="logCell" style={{width: '90%', margin: 10, padding: 5}} key={log.id}>
              <div className="log-row">
                  <div className="catchDetailBox">
                    <div className="details1">
                      <div className="logBoatName">{log.boatName}</div>
                    </div> 
                    <div className="details2">
                      <div className="logTimeCat">{log.total} Pts.</div>
                    </div> 
                  </div>
              </div>
            </div>
          ))}
        </Slider> : <div style={{color: '#fff', fontSize: 24}}>No fish logged yet.</div> 
        }
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SpeciesScores.js